import PropTypes from "prop-types";

export default {
	type: PropTypes.oneOf(["button", "submit", "highlight"]),
	url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	onClick: PropTypes.func,
};
